import { BarChart, LineChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';

// Registering from echarts/core keeps the bundle to the charts this application actually draws.
// Importing the `echarts` barrel instead pulls in roughly a megabyte of unused chart types.
// No pie chart is registered: part-to-whole is drawn as a stacked bar (see StackedShareBar).
echarts.use([
  BarChart,
  CanvasRenderer,
  GridComponent,
  LegendComponent,
  LineChart,
  TooltipComponent,
]);

export { echarts };
